module.exports = __webpack_public_path__ + "static/designer.4a22c2ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/designer.png
// module id = 1696
// module chunks = 173894859265406